import { FilterContext } from '@finn/ua-vehicle';
import { AppContext } from '@finn/ui-modules';
import { useContext } from 'react';

import PageBreadcrumbs from '../PageBreadcrumbs';

const PLPTitle = () => {
  const { title } = useContext(FilterContext);
  const { triggerDevModal } = useContext(AppContext);

  return (
    <>
      <PageBreadcrumbs />
      {/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */}
      <h1
        onClick={triggerDevModal}
        data-testid="page-title"
        className="-mt-4 truncate pb-2 pt-1 global-t5-semibold md:-mt-3 md:pb-4"
      >
        {title}
      </h1>
    </>
  );
};

export default PLPTitle;
